import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import {
  FilterNames,
  DEFAULT_FILTER_NAME,
  DEFAULT_FILTER_DATA,
  DEFAULT_FILTER_LABEL,
  DEFAULT_DATE_FILTER_DATA,
} from './filters.constants';

export const { Types: FiltersTypes, Creators: FiltersActions } = createActions(
  {
    setCurrentFilterName: ['filterName'],
    animateModalByFilterName: ['filterName'],
    showModal: [],
    hideModal: [],
    setFilterDataByFilterName: ['filterName', 'data'],
    setFilterDataByFilterNameSuccess: ['filterName', 'data'],
    setFilter: ['filterName', 'label', 'data'],
    setLocationFilterBasedOnSlug: ['slug'],
    setAllFiltersData: ['filtersData'],
    clearAllFiltersData: null,
    submitFilters: ['query'],
  },
  { prefix: 'FILTERS_' }
);

const INITIAL_FILTER_LIST = {
  [FilterNames.LOCATION]: { name: FilterNames.LOCATION, label: DEFAULT_FILTER_LABEL, data: DEFAULT_FILTER_DATA },
  [FilterNames.DATE]: { name: FilterNames.DATE, label: DEFAULT_FILTER_LABEL, data: DEFAULT_DATE_FILTER_DATA },
  [FilterNames.GUESTS]: { name: FilterNames.GUESTS, label: DEFAULT_FILTER_LABEL, data: DEFAULT_FILTER_DATA },
  [FilterNames.ACTIVITIES]: {
    name: FilterNames.ACTIVITIES,
    label: DEFAULT_FILTER_LABEL,
    data: DEFAULT_FILTER_DATA,
  },
};

export const INITIAL_STATE = Immutable({
  isModalVisible: false,
  currentFilterName: DEFAULT_FILTER_NAME,
  list: INITIAL_FILTER_LIST,
});

const setCurrentFilterNameHandler = (state, { filterName }) => state.set('currentFilterName', filterName);

const setFilter = (state, { filterName, label, data }) =>
  state.setIn(['list', filterName, 'label'], label).setIn(['list', filterName, 'data'], data);

const clearAllFiltersDataHandler = state => state.set('list', INITIAL_FILTER_LIST);

const setAllFiltersDataHandler = (state, { filtersData }) => state.set('list', filtersData);

const showModal = state => state.set('isModalVisible', true);

const hideModal = state => state.set('isModalVisible', false);

export const reducer = createReducer(INITIAL_STATE, {
  [FiltersTypes.SET_CURRENT_FILTER_NAME]: setCurrentFilterNameHandler,
  [FiltersTypes.SET_FILTER]: setFilter,
  [FiltersTypes.SET_ALL_FILTERS_DATA]: setAllFiltersDataHandler,
  [FiltersTypes.CLEAR_ALL_FILTERS_DATA]: clearAllFiltersDataHandler,
  [FiltersTypes.SHOW_MODAL]: showModal,
  [FiltersTypes.HIDE_MODAL]: hideModal,
});
